import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { Routes } from '@/constants/routes'

const RequestView = () =>
  import(/* viteChunkName: "request-view" */ '../views/RequestView.vue')

const LoginView = () =>
  import(/* viteChunkName: "login-view" */ '../views/LoginView.vue')

const MyQueriesView = () =>
  import(/* viteChunkName: "my-queries-view" */ '../views/MyQueriesView.vue')

const ChannelView = () =>
  import(/* viteChunkName: "channel-view" */ '../views/ChannelView.vue')

const ChannelByListView = () =>
  import(
    /* viteChunkName: "channel-by-list-view" */ '../views/ChannelByListView.vue'
  )

const AuditFileView = () =>
  import(/* viteChunkName: "audit-file-view" */ '../views/AuditFileView.vue')

const PersonIdentifyView = () =>
  import(
    /* viteChunkName: "person-identify-view" */ '../views/PersonIdentifyView.vue'
  )

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    redirect: '/minhas-queries',
    meta: { logged: true }
  },
  {
    path: Routes.myQueries,
    name: 'minhas-queries',
    component: MyQueriesView,
    meta: { logged: true },
    alias: '/'
  },
  {
    path: Routes.login,
    name: 'login',
    component: LoginView
  },
  {
    path: Routes.request,
    name: 'requisitar',
    component: RequestView,
    meta: { logged: true }
  },
  {
    path: Routes.channel,
    name: 'canais',
    component: ChannelView,
    meta: { logged: true }
  },
  {
    path: Routes.channelByList,
    name: 'canais_lista',
    component: ChannelByListView,
    meta: { logged: true }
  },
  {
    path: Routes.files,
    name: 'arquivos',
    component: AuditFileView,
    meta: { logged: true }
  },
  {
    path: Routes.identifyMember,
    name: 'identificar_membor',
    component: PersonIdentifyView,
    meta: { logged: true }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
